const fonts = {
  heading: "'Poppins','Arial',serif",
  body: "'Poppins','Arial',serif",
  sizes: {
    h1: '2.1875rem',
    h2: '1.375rem',
    h3: '1.25rem',
    h4: '1.125rem',
    h5: '1rem',
    h6: '0.875rem',
    text: '1rem',
    menuIcon: '1.5rem',
    formError: '0.875rem'
  }
};

export { fonts };
